import {
  Button,
  DialogContent,
  DialogTitle,
  ModalClose,
  ModalDialog,
  Option,
  Select,
} from "@mui/joy";
import {
  ApiCompetition,
  ApiCompetitionEntryDetail,
  ApiCompetitionEntryInline,
} from "griptonite-api-client";
import { useState } from "react";

import { useUpdateEntryMutation } from "@/hooks/competitions";

import { useModal } from "./useModal";

export const ChangeCompetitorCategory = ({
  competition,
  entry,
}: {
  competition: ApiCompetition;
  entry: ApiCompetitionEntryInline | ApiCompetitionEntryDetail;
}) => {
  const { close } = useModal();

  const mutation = useUpdateEntryMutation();

  const [categoryUuid, setCategoryUuid] = useState(
    typeof entry.category === "string" ? entry.category : entry.category.uuid,
  );

  return (
    <ModalDialog>
      <ModalClose />
      <DialogTitle>Change category</DialogTitle>
      <DialogContent>
        <Select value={categoryUuid} onChange={(_e, v) => v && setCategoryUuid(v)}>
          {competition.stages[0].categories.map((category) => (
            <Option key={category.uuid} value={category.uuid}>
              {category.name}
            </Option>
          ))}
        </Select>

        <Button
          sx={{ width: "100%", mt: 1 }}
          type="submit"
          loading={mutation.isPending}
          loadingPosition="start"
          onClick={() => {
            mutation.mutate(
              {
                competitionUuid: competition.uuid,
                userUuid: entry.user.uuid,
                data: {
                  category: categoryUuid,
                },
              },
              {
                onSuccess: () => close(),
              },
            );
          }}
        >
          Save
        </Button>
      </DialogContent>
    </ModalDialog>
  );
};
